import {AudioPlayerControlTagNameType} from './audio-player-control-button-type';

export const audioPlayerControlTagNameMap: Record<AudioPlayerControlTagNameType, AudioPlayerControlTagNameType> = {
    div: 'div',
    span: 'span',
};
